import { useMemo } from "react";

export const useSecureMediaUrl = () => {
  const apiBase = process.env.REACT_APP_API_URL; 

  const toSecureMediaUrl = (raw) => {
    if (!raw) return "";

    if (raw.includes("/sw.om.api/v1/Image/")) {
      return raw;
    }

    if (raw.startsWith("http") && raw.includes("/screenshots/")) {
      const suffix = raw.split("/screenshots/")[1];
      return `${apiBase}/Image/${suffix}`;
    }

    if (raw.startsWith("/screenshots/")) {
      const suffix = raw.replace("/screenshots/", "");
      return `${apiBase}/Image/${suffix}`;
    }

    if (raw.startsWith("screenshots/")) {
      const suffix = raw.replace("screenshots/", "");
      return `${apiBase}/Image/${suffix}`;
    }

    return raw;
  };

  return useMemo(() => ({ toSecureMediaUrl }), [apiBase]);
};
